<ng-container *ngIf="!teamSquadService.loading">
  <ng-container *ngFor="let trainerGroup of teamSquadService.squadTrainersGrouped">
    <div class="mb-2" *ngIf="trainerGroup.objects.length > 0">
      <div class="seperator-headline">
        <div class="seperator-headline__line"></div>
        <h5>{{trainerGroup.position}}</h5>
      </div>
      <div class="player__cards-wrapper">
        <div *ngFor="let trainer of trainerGroup.objects" class="player__card">
          <app-player-card [player]="trainer"></app-player-card>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
<p class="no-infos-available"
   *ngIf="!teamSquadService.loading && !hasTrainers()">Keine Spieler eingetragen</p>
